import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { initialize, submit } from 'redux-form';
import { PERMISSIONS, PERMISSION_ENTITIES } from '../../../_config/consts';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import * as GatewaysActions from '../../../redux/actions/gateways.actions';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import * as WearableActions from '../../../redux/actions/wearable.actions';
import WearableSettingsForm, { convertMsToSeconds } from '../../forms/WearableForm/WearableSettingsForm.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import Permission from '../../Permission/Permission.jsx';


@connect(() => ({}))
class WearablesManagementSettingsOperationalSection extends React.Component {


  async componentDidMount() {
    const { dispatch, setting } = this.props;
    try {
      const configuration = await dispatch(GatewaysActions.fetchGatewayConfiguration());
      if (configuration && configuration.wearables) {
        const formattedResponse = {
          wearableEmergencyIdleTime: convertMsToSeconds(configuration.wearables.wearableEmergencyIdleTimeMs),
          wearableDataIdleTime: convertMsToSeconds(configuration.wearables.wearableDataIdleTimeMs),
          wearableAccelerometerDataIdleTime: convertMsToSeconds(configuration.wearables.wearableAccelerometerDataIdleTimeMs),
          wearableDataRssiThreshold: configuration.wearables.wearableDataRssiThreshold,
        };
        dispatch(initialize('WearableSettingsForm', formattedResponse));
      }
    } catch (error) {
      throw error;
    }
  }

  async saveWearableSettings(values) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(WearableActions.updateWearableSettings(values));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="settingUpdateSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="settingUpdateError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { dispatch } = this.props;
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25 }}>
        <WearableSettingsForm
          onSubmit={values => this.saveWearableSettings(values)}
        />
        <div style={{ backgroundColor: 'white', position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}>
          <Permission do={[PERMISSIONS.UPDATE]} on={PERMISSION_ENTITIES.COMPANY} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MDButton
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              title={<Entity entity="save" />}
              onClick={() => dispatch(submit('WearableSettingsForm'))}
            />
          </Permission>
          </div>
      </div>
    );
  }
} 

export default WearablesManagementSettingsOperationalSection;
